var jsom = Object.assign({}, require("./utils"));
jsom.mms = require("./mms");
jsom.webProperties = require("./webProperties");

module.exports = jsom;



// WEBPACK FOOTER //
// ./src/scripts/jsom/index.js